import { createContext } from 'react';
import * as logger from 'src/lib/logger';

const LoggerContext = createContext<logger.types.Logger<string>>(logger.unit);

const { Provider: LoggerProvider } = LoggerContext;

export { LoggerContext, LoggerProvider };
